$(document).on('click', '.quickshop-button .productitem--action-trigger', function(){
  $(".productitem--action-trigger").removeClass("proactive");
  $(this).addClass("proactive");
  var origin 			 = window.location.origin;
  var explode_str 	 = origin.split("//");
  var shop 			 = explode_str[1];
  var product_id 	 	 = $(this).attr("product_id");
  var variant_id	 	 = $(this).attr("variant_id");
  var variant_barcode	 = $(this).attr("barcode");
  var product_price  	 = $('.price__current span').text().trim();
  var pro_price = $(this).attr("variant_price");
  var variant_quantity = $(this).attr("variant_quantity");
  //console.log("quantity", variant_quantity)

      if(pro_price != '$0.00') {
        $('.priceProduct').text(pro_price);
        $('#ProductPrice').text(pro_price);
      } else {
        $('#ProductPrice').css('display', 'none');
        $('#AddToCart').attr("disabled", "true");
        $('#AddToCart').addClass("disabled");
        $('#AddToCartText').text("Sold Out");
        //$('.notify_button').html('<button id="BIS_trigger"  data-variant-id="'+variant_id+'">NOTIFY ME WHEN AVAILABLE</button>');
        $('.productAvailability1').addClass("outstock productAvailability");
        $('.productAvailability1').addClass("pro_outofstock productAvailability");
        $('.productAvailability1').removeClass("instock");
      }
       console.log("Proctive"+variant_barcode);
      if(variant_barcode) {
        jQuery.ajax({
          url: 'https://fridgeparts.us/liebherrpartsapp/admin_ajax.php',
          type: 'POST',
          data: {
            action			: 'get_product_price',
            shop				: shop,
            variant_barcode 	: variant_barcode,
            variant_id    	: variant_id,
            product_price		: pro_price,         
            product_id    	: product_id,
            variant_quantity  : variant_quantity
          },
          success: function(result){
            jQuery('#ComparePrice').css('display', 'none');
            var response = JSON.parse(result);

                      var location_size = response.shipping_loc_size;
          var location_size_city = response.shiping_loc_city;

          if(location_size == 1 && location_size_city == 'Greenwood, IN' ){
            console.log("locationcheck",location_size_city);
            $(document).find('#AddToCart').attr("disabled", "true");
            $(document).find('#AddToCart').addClass("disabled");
            $(document).find('.atc-button--text').text("Sold Out");
    		$(document).find('.notify_button').hide();	
            $(document).find('.productAvailability1').addClass("outstock productAvailability");
            $(document).find('.productAvailability1').addClass("pro_outofstock productAvailability");
            $(document).find('.productAvailability1').removeClass("instock");
            return;
          }          

          if(response.substitutePartNumber != '') {
             $(document).find('#noPurchaseReason').show();
            $(document).find('.productAvailability1').hide();
            $(document).find('#noPurchaseReason').html((`<p>  This part is not available. You can order substitute part ${response.substitutePartNumber} ! <br/> <a href="/products/lie${response.substitutePartNumber}"><b>View Subsitute Part:- ${response.substitutePartNumber} </b></a></p>`));
            $(document).find('.pro-details').css('display', 'none');
            $(document).find('.noPurchaseReason').css('display', 'block');
            $(document).find('.product-form--atc-button').attr("disabled", "true");
            $(document).find('.product-form--atc-button').addClass("disabled");
            return;
          }
		

          if(response.noPurchaseReason != '') {
            $('#noPurchaseReason').text(response.noPurchaseReason);
            $('.pro-details').css('display', 'none');
            $('.noPurchaseReason').css('display', 'block');
          }
          
          if(response.newPartNumber) {
            var newPartNumber = response.newPartNumber;
            newPartNumber = newPartNumber.replace("/", "-");
            var originalPart = response.originalPart;
            if(newPartNumber != originalPart) {
              $(".subsitutemsg").css("display","block");
              $(".formAddToCart.clearfix").css("display","none");
              jQuery('.product-form--regular').css("display","none");
			  $(".subsitutemsg").append('<div class="subscontent"><p class="subsmaincontent"> This part is no longer available, but the part(s) listed below is comparable and can be used instead. ! <br/> View Substitute part : <a href="/products/lie'+newPartNumber+'">'+newPartNumber+'</a></p></div>  <div class="subslink"><a class="btn redirectedbtn" href="/products/lie'+newPartNumber+'"><b>View Part</b></a></div>');          
            $(document).find('.productAvailability1').hide();
              return;
            }
            if(newPartNumber == originalPart) {
              var partEta = response.partEta;
              jQuery('.substitute-resp').show();
              jQuery('.substitute-value').text(newPartNumber);
              jQuery('.product-form--regular').css("display","none");           
              jQuery('#AddToCart').attr("disabled", "true");
              jQuery('#AddToCart').addClass("disabled");
              jQuery('#AddToCartText').text("Sold Out");
			 // jQuery('.notify_button').html('<button id="BIS_trigger" data-variant-id="'+variant_id+'">NOTIFY ME WHEN AVAILABLE</button>');
              jQuery('.productAvailability1').addClass("outstock productAvailability");
              jQuery('.productAvailability1').addClass("pro_outofstock productAvailability");
              jQuery('.productAvailability1').removeClass("instock");
              jQuery('.productAvailability1').html("<label>Availability:</label> not available for resale");
              
             } 
            //else {
//               window.location.href = "/products/"+newPartNumber+"?op="+originalPart;
//             }
          }

            if(response.quantity != 0) {
              var quantity = response.quantity;
              //               alert(quantity);
              jQuery('#AddToCart').removeAttr("disabled");
              jQuery('#AddToCart').removeClass("disabled");
              jQuery('#AddToCartText').text("Add to Cart");

              jQuery('.productAvailability1').addClass("instock productAvailability");
              jQuery('.productAvailability1').removeClass("outstock");
              jQuery('.productAvailability1').removeClass("pro_outofstock");
              if(product_id != '') {//5501745430684
                jQuery('.productAvailability1').html("<label>Availability:</label><span class='instock'>In Stock</span>");//<span> - order placed today by 3pm EST will ship <span class='guaranteed_tooltip'><span class='guaranteed'><b>Today</b></span><div class='gttooltip'><div class='tooltip_header'><p class='oadatb-button' oada-type='button'>Fast, Convenient Delivery!</p></div><p>We know you need your parts shipped and delivered FAST!</p><p style='font-size: 15px!important; font-weight: 600!important; line-height: 20px!important; color: #000!important;'>Any IN STOCK order placed today by 3pm will ship TODAY or you will receive 20% off your next order.</p><p>We strive to provide you with the most accurate ETAs and updates for Out of Stock items.</p></div></span></span>
              } else {
                jQuery('.productAvailability1').html("<label>Availability:</label><span class='instock'>In Stock</span>");
              }
            } else {
              var quantity = response.quantity;
              var partEta = response.partEta;

              if(partEta == 'no longer available') { // == no longer available
                
                jQuery('.product-form--atc-button').attr("disabled", "true");
                jQuery('.product-form--atc-button').addClass("disabled");
                jQuery('.atc-button--text').text("Sold Out");
				//jQuery('.notify_button').html('<button id="BIS_trigger" data-variant-id="'+variant_id+'" >NOTIFY ME WHEN AVAILABLE</button>');	
                jQuery('.productAvailability1').addClass("outstock productAvailability");
                jQuery('.productAvailability1').addClass("pro_outofstock productAvailability");
                jQuery('.productAvailability1').removeClass("instock");
                jQuery('.productAvailability1').text(response.partEta);
              }else if(partEta == 'Today'){
                jQuery('.productAvailability1').html("<label>Availability:</label> <span class='instock'>In Stock </span>"+partEta+"");
                jQuery('#AddToCart').removeAttr("disabled");
                jQuery('#AddToCart').removeClass("disabled");
                jQuery('#AddToCartText').text("Add to Cart");
                jQuery('.productAvailability1').removeClass("outstock productAvailability");
                jQuery('.productAvailability1').removeClass("pro_outofstock productAvailability");
                jQuery('.productAvailability1').addClass("instock");
                //jQuery('.notify_button').html('<button id="BIS_trigger" data-variant-id="'+variant_id+'">NOTIFY ME WHEN AVAILABLE</button>');
              } else if(partEta == 'No ETA - Factory Backorder'){
                jQuery('.productAvailability1').html("<label>Availability:</label> <span class='instock'>In Stock </span>"+partEta+"");
                jQuery('#AddToCart').removeAttr("disabled");
                jQuery('#AddToCart').removeClass("disabled");
                jQuery('#AddToCartText').text("Add to Cart");
                jQuery('.productAvailability1').removeClass("outstock productAvailability");
                jQuery('.productAvailability1').removeClass("pro_outofstock productAvailability");
                jQuery('.productAvailability1').addClass("instock");
                //jQuery('.notify_button').html('<button id="BIS_trigger" data-variant-id="'+variant_id+'">NOTIFY ME WHEN AVAILABLE</button>');
              }else if(partEta == 'No ETA - Delivery Not Available'){
               
                jQuery('.productAvailability1').html("<label>Availability:</label> <span style='color:red' class='outstock'>"+partEta+ "</span>");
                jQuery('#AddToCart').removeAttr("disabled");
                jQuery('#AddToCart').removeClass("disabled");
                jQuery('#AddToCartText').text("Add to Cart");
                jQuery('.productAvailability1').removeClass("outstock productAvailability");
                jQuery('.productAvailability1').removeClass("pro_outofstock productAvailability");
                jQuery('.productAvailability1').addClass("instock");
                //jQuery('.notify_button').html('<button id="BIS_trigger" data-variant-id="'+variant_id+'">NOTIFY ME WHEN AVAILABLE</button>');
              }  else {
                
//                 jQuery('#AddToCart').attr("disabled", "true");
//                 jQuery('#AddToCart').addClass("disabled");
//                 jQuery('#AddToCartText').text("Sold Out");
                
//                 jQuery('.productAvailability').addClass("outstock");
//                 jQuery('.productAvailability').addClass("pro_outofstock");
//                 jQuery('.productAvailability').removeClass("instock");
                
                jQuery('.product-form--atc-button').removeAttr("disabled");
                jQuery('.product-form--atc-button').removeClass("disabled");
                //jQuery('#AddToCartText').text("Add to Cart");
                jQuery('.atc-button--text').text("Add to Cart");
                //jQuery('.notify_button').html('<button id="BIS_trigger" data-variant-id="'+variant_id+'">NOTIFY ME WHEN AVAILABLE</button>');
                jQuery('.productAvailability1').addClass("outstock productAvailability");
                jQuery('.productAvailability1').addClass("pro_outofstock productAvailability");
                jQuery('.productAvailability1').removeClass("instock");
                //jQuery('.productAvailability1').text(response.partEta);
//                 jQuery('.formAddToCart').append('<button id="BIS_trigger" type="button" class="btn" style="background-color: rgb(44, 49, 146); color: white; width: 324px; font-weight: bold;">NOTIFY ME WHEN AVAILABLE</button>');
               jQuery('.productAvailability1').html("<label>Availability:</label> <span class='outstock'> Expected to be available on ("+partEta+")");
              }
            }
            if(response.price != "") {
              var price = response.price;
              jQuery('.modal--quickshop-full .price__current span').text(price);
            }
            if(response.old_price != "") {
              jQuery('.product-old-price').css('display', 'block');
              jQuery('.save-price').append(response.save_price);
              jQuery('.old-amount').append(response.old_price);
            }
            if(response.core_price != "0.00") {
              jQuery('.part_core_price').css('display', 'block');
              jQuery("li.part_price").find('span').text(response.part_price);
              jQuery("li.core_price").find('span').text(response.core_price);
              if(response.price != response.part_price){
                  sessionStorage.setItem('partprice', variant_sku+":"+response.part_price);
                }
            }
            if(response.shippingInfo != "") {
              jQuery('#shipping').html(response.shippingInfo);
            }
            if(response.compatibleModels != "") {
              jQuery('#compatible').html('');
              var modelCount = response.compatibleModels.length;

              for (var i = 0; i < modelCount; i++) {
                var model = response.compatibleModels[i];
                var modelLink = model.replace("/", "-");
                jQuery('#compatible').append('<a class="compatible_model_name" href="/products/'+modelLink+'">'+model+'</a>');
              }
            }
            if(response.equivalentParts != "") {
              jQuery('#relatedProducts .title').text('Equivalent Parts');
              jQuery('.mainContent #relatedProducts .owl-stage').html(response.equivalentParts);
              jQuery('.mainContent #relatedProducts .owl-nav').addClass('disabled');
            } else {
              jQuery('.proRelated').css('display','block');
            }
            if(response.fbtParts != "") {
              jQuery('.proBoxPrimaryInner').append(response.fbtParts);
            }
          }
        });
      } else {
        jQuery('.btnAddToCart').attr("disabled", "true");
      }
  
  jQuery(document).on('click','.custom-readmore', function(){
    var text = $(this).text();
    if( text == "Read More"){
    	$(".custom-readmore").html("Read Less");
    }else{
    	$(".custom-readmore").html("Read More");
    }
    $(".custom-desc").toggleClass("show");
    $(".product-description").toggleClass("hide");
  });
});